function _templateObject() {
  var data = _taggedTemplateLiteral(["\n      ", ";\n      line-height: ", "\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { css } from 'styled-components';
import { media } from '../../../mixins/media';
import { fontSize } from '../../../mixins/fontSize';
export function mobileResponsiveXs(xsSize, otherSize, lineHeight) {
  return css(["", " ", ";"], media.xs(_templateObject(), fontSize(xsSize), lineHeight), fontSize(otherSize));
}